import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedResult, PaginationParams } from '@core/common/models/pagination.models';
import { ProductAttributeValue } from '@features/catalog/models/product-attribute-definition.models';
import { AttributeValueMutationResult, AttributeValueSiblingEnablementResult } from '@features/catalog/models/product-attribute-value.models';
import { AttributeValueApiService } from '@features/catalog/data-access/attribute-value-api.service';

@Injectable()
export class CatalogAttributeValueService {
  constructor(private readonly valueApi: AttributeValueApiService) {}

  list(
    productAttributeDefinitionId: string,
    activeOnly: boolean | null = true,
    pagination?: PaginationParams
  ): Observable<PaginatedResult<ProductAttributeValue>> {
    return this.valueApi.list(productAttributeDefinitionId, activeOnly, pagination);
  }

  create(input: {
    productAttributeDefinitionId: string;
    value: string;
    position?: number | null;
    active?: boolean;
  }): Observable<AttributeValueMutationResult> {
    return this.valueApi.create(input);
  }

  enableOnSiblingProducts(input: {
    productAttributeDefinitionId: string;
    value: string;
    productIds?: string[] | null;
    excludeProductId?: string | null;
  }): Observable<AttributeValueSiblingEnablementResult> {
    return this.valueApi.enableOnProducts(input);
  }

  update(input: {
    id: string;
    value?: string;
    position?: number | null;
    active?: boolean;
  }): Observable<AttributeValueMutationResult> {
    return this.valueApi.update(input);
  }

  destroy(id: string): Observable<AttributeValueMutationResult> {
    return this.valueApi.destroy(id);
  }

  deactivate(id: string): Observable<AttributeValueMutationResult> {
    return this.valueApi.destroy(id);
  }

  reactivate(id: string): Observable<AttributeValueMutationResult> {
    return this.valueApi.updateActive(id, true);
  }

  permanentlyDelete(id: string): Observable<{ success: boolean; errors: string[] }> {
    return this.valueApi.permanentlyDelete(id);
  }
}
